import React from "react";
import { useSelector } from "react-redux";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
} from "../../constants/ThemeSetting";
import { useAuth } from "../../authentication";

const SubMenu = Menu.SubMenu;

const HorizontalNav = () => {
  const navStyle = useSelector(({ settings }) => settings.navStyle);
  const pathname = useSelector(({ common }) => common.pathname);

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];
  const { authUser, isLoadingUser } = useAuth();
  const getNavStyleSubMenuClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-inside-submenu-popup-curve";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-below-submenu-popup-curve";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-above-submenu-popup-curve";
      default:
        return "gx-menu-horizontal";
    }
  };

  return (
    <Menu
      defaultOpenKeys={[defaultOpenKeys]}
      selectedKeys={[selectedKeys]}
      mode="horizontal"
    >
      <SubMenu
        className={getNavStyleSubMenuClass(navStyle)}
        key="main"
        title="اطلاعات وب سایت"
      >
              <Menu.Item key="baseData/projects">
                <Link to="/baseData/projects">
                  <i className="icon icon-dasbhoard" />
                  پروژه ها
                </Link>
              </Menu.Item>
              <Menu.Item key="baseData/standards">
                <Link to="/baseData/standards">
                  <i className="icon icon-dasbhoard" />
                  استاندارد ها
                </Link>
              </Menu.Item>
              <Menu.Item key="baseData/setting">
                <Link to="/baseData/setting">
                  <i className="icon icon-dasbhoard" />
                  اطاعات پایه وب سایت
                </Link>
              </Menu.Item>
              <Menu.Item key="website/sliders">
                <Link to="/website/sliders">
                  <i className="icon icon-dasbhoard" />
                  اسلایدر
                </Link>
              </Menu.Item>

      </SubMenu>

      <SubMenu
        className={getNavStyleSubMenuClass(navStyle)}
        key="contactus"
        title="ارتباط با ما"
      >
              <Menu.Item key="website/contactUs">
                <Link to="/website/contactUs">
                  <i className="icon icon-dasbhoard" />
                  ارتباط با ما
                </Link>
              </Menu.Item>

      </SubMenu>

    </Menu>
  );
};

HorizontalNav.propTypes = {};

export default HorizontalNav;
